import { render, staticRenderFns } from "./BookEditDetailsTab.vue?vue&type=template&id=e7da189a"
import script from "./BookEditDetailsTab.vue?vue&type=script&lang=js"
export * from "./BookEditDetailsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports